import { createContext } from "react";
import { GameCode } from "src/core/casino/casino.model";

export default createContext<GameCode | null>(null);
